export default{
    
    data() {
        return{
            StoreLogs:[],
            recordtotal:0,
            pageSize:30,
            pageIndex:1,
            editFormVisible:false,
            editForm:[],
            formLabelWidth: '90px',
            currentRowIndex:-1,
            bIsNew:false,
            listLoading:false,
            sCustomerName:'',
            sProName:'',
            sProCode:'',
            sInOut:'',
            sInputDtFrom:'',
            sInputDtTo:'',

            customers:[],
            productions:[],
            
            Weight:0,
            Cube:0,
            TotalCube:0,
            TotalWeight:0,

            'CustomerNameOrder':'',
            'ProNameOrder': '',
            'ProCodeOrder': '',
            'InOutOrder': '',
            'InputDateOrder': '',
            
        }
    },
    mounted () {
        var me = this;
        this.getcustomers();
        this.getProductions();
        this.LoadData();
    },
    methods: {
        getcustomers(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = "common/getcustomerlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.customers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        getProductions(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = "common/getproductionlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.productions = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        LoadData(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = 'StoreLog/getlist';
            this.$axios.get(getMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,
                        'CustomerName':me.sCustomerName,
                        'ProName':me.sProName,
                        'ProCode':me.sProCode,
                        'InOut':me.sInOut,
                        'InputDtFrom':me.sInputDtFrom,
                        'InputDtTo':me.sInputDtTo,
                        'CustomerNameOrder':me.CustomerNameOrder,
                        'ProNameOrder':me.ProNameOrder,
                        'ProCodeOrder':me.ProCodeOrder,
                        'InOutOrder':me.InOutOrder,
                        'InputDateOrder':me.InputDateOrder,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                    }
                })
            .then((response) => {
                if (response.data !='undefined' && response.data != null) {
                        me.StoreLogs = response.data.DataSource;
                        me.recordtotal = response.data.TotalRecords;
                }
            })
            .catch(function (error) {
                console.log(error)
            });

            this.listLoading = false;
        },
        
        handleCurrentChange(val)
        {
            this.pageIndex = val;
            this.LoadData()
        },
        handleAdd(){
            this.bIsNew = true;
            this.currentRowIndex = -1;
            this.editFormVisible = true;
            this.editForm = Object.assign({}, {
                    'Id': 0,
                    'CustomerId': '',
                    'ProId': '',
                    'Count':0.00,
                    'InOut': 'In',
                    'InputDate': '',
                    'Remark':'',           
            }); //这句是关键！！！
        },
        handleRefresh()
        {
            this.listLoading = true;
            this.LoadData();
        },
        changeTableSort(column) {
             if (column.prop === 'CustomerName') {
                if (column.order === 'descending') {
                    this.CustomerNameOrder = "Desc";
                } else if (column.order === 'ascending') {
                   this.CustomerNameOrder = "Asc";
                }
                this.ProNameOrder = "";
                this.ProCodeOrder = "";
                this.InOutOrder = "";
                this.InputDateOrder = "";
              } 
              else if (column.prop === 'ProName') {
                if (column.order === 'descending') {
                    this.ProNameOrder = "Desc";
                } else if (column.order === 'ascending') {
                    this.ProNameOrder = "Asc";
                }
                this.CustomerNameOrder = "";
                this.ProCodeOrder = "";
                this.InOutOrder = "";
                this.InputDateOrder = "";
              } 
              else if (column.prop === 'ProCode') {
                if (column.order === 'descending') {
                    this.ProCodeOrder = "Desc";
                } else if (column.order === 'ascending') {
                    this.ProCodeOrder = "Asc";
                }
                this.CustomerNameOrder = "";
                this.ProNameOrder = "";
                this.InOutOrder = "";
                this.InputDateOrder = "";
              } 
              else if (column.prop === 'InOut') {
                if (column.order === 'descending') {
                    this.InOutOrder = "Desc";
                } else if (column.order === 'ascending') {
                    this.InOutOrder = "Asc";
                }
                this.CustomerNameOrder = "";
                this.ProCodeOrder = "";
                this.ProNameOrder = "";
                this.InputDateOrder = "";
              } 
              else if (column.prop === 'InputDate') {
                if (column.order === 'descending') {
                    this.InputDateOrder = "Desc";
                } else if (column.order === 'ascending') {
                    this.InputDateOrder = "Asc";
                }
                this.CustomerNameOrder = "";
                this.ProCodeOrder = "";
                this.InOutOrder = "";
                this.ProNameOrder = "";
              } 

              this.LoadData();
        },
        handleEdit(index, row) {
            this.bIsNew = false;
            this.currentRowIndex = index;
            this.editFormVisible = true;
            
            this.editForm = Object.assign({}, row); //这句是关键！！！

            this.handleProChanged(this.editForm.ProId);


          },
        //点击关闭dialog
        handleClose(done) {
            /*done();
            location.reload();*/
            this.editFormVisible = false;
        },  
        //点击取消
        handleCancel() {
            this.editFormVisible = false;
        },
        //点击更新
        handleUpdate() { 
            this.editFormVisible = false;

            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            //Save Production
            var getMethod = 'StoreLog/save';

            debugger
            this.$axios.post(getMethod,
                {
                    'CurrentTokenId': user.TokenId,
                    'CurrentUser': user.LoginName,                 
                    'Id': me.editForm.Id,
                    'CustomerId': me.editForm.CustomerId,
                    'ProId': me.editForm.ProId,
                    'Count':me.editForm.Count,
                    'InOut': me.editForm.InOut,
                    'InputDate': me.editForm.InputDate,
                    'Remark': me.editForm.Remark,    
                    'TotalCube':   me.TotalCube,
                    'TotalWeight':  me.TotalWeight,
                })
            .then((response) => {
                    if(response.data.IsSuccess)
                    {
                        this.$message("保存成功.")

                        this.LoadData();
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        console.log(strMsg);
                    }
            })
            .catch(function (error) {
                console.log(error);
            }); 
        },

          handleDelete(index, row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              }).then(() => {
                var me = this;
                    var user = sessionStorage.getItem('user');
                    if (user) {
                        user = JSON.parse(user);
                    }

                    var Method = 'StoreLog/delete/'+user.TokenId+"/"+user.LoginName+"/"+ row.Id;
                    this.$axios.post(Method)
                    .then((response) => {
                        if (response.status === 200) {
                            if(response.data.IsSuccess)
                            {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            
                                this.LoadData();
                            }
                            else
                            {
                                var strMsg = '';
                                response.data.Messages.forEach(element => {
                                    strMsg += element.Message +'\r\n';
                                });
                                
                                this.alert(strMsg);
                            }
                        
                        }
                    })
                    .catch(function (error) {
                        this.alert(error);
                    }); 
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
          },
          formatterController:function(row, column) { 
            var date_str = row[column.property];
            if (date_str === undefined) {
              return "";
            }
            var date = new Date(date_str);
            return date.Format("yyyy-MM-dd");
        },
        handleProChanged(value){
            
            this.productions.forEach(element=>{
                if(value == element.Id)
                {
                    this.Weight = element.Weight;
                    this.Cube = element.Cube;
                    this.TotalCube = this.Cube * this.editForm.Count;
                    this.TotalWeight = this.Weight * this.editForm.Count;
                }
            });
            
        },
        handleChangeCount(){
            
            this.TotalCube = this.Cube * this.editForm.Count;
            this.TotalWeight = this.Weight * this.editForm.Count;
           
        },

        handleExport(){
            this.searching = true;
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }

            var getMethod = 'StoreLog/export';
            this.$axios.get(getMethod,
                {
                    params: {
                        'CurrentTokenId': user.TokenId,
                        'CurrentUser': user.LoginName,
                        'CustomerName':me.sCustomerName,
                        'ProName':me.sProName,
                        'ProCode':me.sProCode,
                        'InOut':me.sInOut,
                        'InputDtFrom':me.sInputDtFrom,
                        'InputDtTo':me.sInputDtTo,
                        'CustomerNameOrder':me.CustomerNameOrder,
                        'ProNameOrder':me.ProNameOrder,
                        'ProCodeOrder':me.ProCodeOrder,
                        'InOutOrder':me.InOutOrder,
                        'InputDateOrder':me.InputDateOrder,
                        'PageSize':me.pageSize,
                        'CurrentIndex':me.pageIndex -1,
                    }
                })
            .then((response) => {

               // this.searching = false;

                if(true) {
                    if(response.data.IsSuccess)
                    {
                        //TODO: Download the file
                        //var attachmentURL = "http://bxw2341450056.my3w.com/api/tempexportfile/" + response.data.Data;
                       // window.location = attachmentURL;
                       me.downloadFile('export.xlsx',response.data.Data);
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
               // this.searching = false;
                console.log(error);
            });
        },
        downloadFile(fileName, content) {
            const blob = this.base64ToBlob(content); // new Blob([content]);
      
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
       
              //此写法兼容可火狐浏览器
              document.body.appendChild(link);
              const evt = document.createEvent("MouseEvents");
              evt.initEvent("click", false, false);
              link.dispatchEvent(evt);
              document.body.removeChild(link);
            }
            },
            base64ToBlob(code) {
            const raw = window.atob(code);
            const rawLength = raw.length;
            const uInt8Array = new Uint8Array(rawLength);
            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        },
    }

}


// WEBPACK FOOTER //
// ./src/components/MaintainStoreLog/MaintainStoreLog.js